import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
} from "@mui/material";

const resourcesData = [
  {
    title: "Learn React",
    description: "A comprehensive guide to learning React from scratch.",
    link: "https://reactjs.org/",
  },
  {
    title: "Material-UI Documentation",
    description: "Official documentation for Material-UI components and usage.",
    link: "https://mui.com/",
  },
  {
    title: "JavaScript Essentials",
    description:
      "A tutorial for understanding the core concepts of JavaScript.",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide",
  },
  {
    title: "CSS Flexbox Guide",
    description: "Learn the fundamentals of CSS Flexbox layout system.",
    link: "https://css-tricks.com/snippets/css/a-guide-to-flexbox/",
  },
  {
    title: "Learn React",
    description: "A comprehensive guide to learning React from scratch.",
    link: "https://reactjs.org/",
  },
  {
    title: "Material-UI Documentation",
    description: "Official documentation for Material-UI components and usage.",
    link: "https://mui.com/",
  },
  {
    title: "JavaScript Essentials",
    description:
      "A tutorial for understanding the core concepts of JavaScript.",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide",
  },
  {
    title: "CSS Flexbox Guide",
    description: "Learn the fundamentals of CSS Flexbox layout system.",
    link: "https://css-tricks.com/snippets/css/a-guide-to-flexbox/",
  },
];

const Resources = () => {
  return (
    <Box sx={{ maxWidth: "lg", mx: "auto", p: 3 }}>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 4 }}>
        Recommended Resources
      </Typography>

      <Grid container spacing={3}>
        {resourcesData.map((resource, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{ fontWeight: "bold" }}
                >
                  {resource.title}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  {resource.description}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  href={resource.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  fullWidth
                >
                  Learn More
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Resources;
